/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetOfficialMarketsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetOfficialMarketsArgs, useGetOfficialMarketsSpec, useGetOfficialMarketsRealtime, useGetOfficialMarketsPagination } from '../specs/markets.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetOfficialMarketsRow } from '../openapi-types.gen.js';
export type { useGetOfficialMarketsArgs } from '../specs/markets.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetOfficialMarketsPaginationContract = useGetOfficialMarketsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetOfficialMarketsInfinite` — both
 * read/write the same `PagedData<GetOfficialMarketsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): status, sortOrder, limit, cursor.
 */
const _useGetOfficialMarkets = createListHook({
  spec: useGetOfficialMarketsSpec,
  realtime: useGetOfficialMarketsRealtime,
  entityKey: 'market',
  pagination: _useGetOfficialMarketsPaginationContract,
});
export const useGetOfficialMarkets = _useGetOfficialMarkets as (args: useGetOfficialMarketsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetOfficialMarkets>;


/**
 * Auto-infinite: same cache as `useGetOfficialMarkets`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetOfficialMarkets` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetOfficialMarketsInfinite = createListHook({
  spec: useGetOfficialMarketsSpec,
  realtime: useGetOfficialMarketsRealtime,
  entityKey: 'market',
  pagination: _useGetOfficialMarketsPaginationContract,
  autoLoadMore: true,
});
export const useGetOfficialMarketsInfinite = _useGetOfficialMarketsInfinite as (args: useGetOfficialMarketsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetOfficialMarketsInfinite>;


/**
 * Per-field subscription hook for the `useGetOfficialMarkets` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetOfficialMarketsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetOfficialMarketsField = createFieldHook<GetOfficialMarketsRow>('useGetOfficialMarketsField');

/**
 * Hover/intent prefetch companion for `useGetOfficialMarkets` (also covers
 * `useGetOfficialMarketsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetOfficialMarkets();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetOfficialMarkets = createPrefetchHook(useGetOfficialMarketsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetOfficialMarketsArgs>;
